<template lang="pug">
    include RecoverPassword.pug
</template>

<script>
import Api from '@/components/services/Api';
import { mapState } from 'vuex';

export default {
  name: 'RecoverPassword',
  computed: mapState([
    "context",
  ]),
  data() {
    return {
      email:"",
      message: "",
      waiting: false,
      error: null,
    }
  },
  methods: {
    perform() {
      const _this = this
      this.waiting = true
      Api.recoverPassword(this.email).then(resp => {
        _this.waiting = false
        _this.email = ""
        _this.message = "Se ha enviado un correo con un enlace para reiniciar el password"
      }).catch(err => {
        _this.waiting = false
        _this.message = "Ha habido un error en el envío del correo electrónico. Por favor, confirme que el correo es válido"
      })
    }
  }
}

</script>

<style scoped lang="scss">
@import './../../variables';
@import "./../../variables_colreps";
@import "./../../variables_mexreps";

@import "RecoverPassword";
@import "RecoverPasswordColreps";
@import "RecoverPasswordMexreps";
</style>



// WEBPACK FOOTER //
// src/components/recover_password/RecoverPassword.vue